import React from 'react'
import styled from 'styled-components'

// images
import SelectImg from '../../../assets/image/radio/ic-select.png'
import UnSelectImg from '../../../assets/image/radio/ic-unselect.png'

function Radio({ options, textColor, selectIdx, onClickRadio }) {
  return options.map((option, idx) => (
    <Container key={idx}>
      <CircleWrapper
        onClick={() => onClickRadio(idx)}
        src={selectIdx === idx ? SelectImg : UnSelectImg}
      />
      <TextWrapper textColor={textColor}>{option}</TextWrapper>
    </Container>
  ))
}

export default Radio

const Container = styled.div`
  display: flex;
  align-items: center;
  margin-right: 24px;
`

const CircleWrapper = styled.img`
  width: 24px;
  height: 24px;
  cursor: pointer;
`

const TextWrapper = styled.div`
  margin-left: 10px;
  color: ${(props) => props.textColor};
  font-size: 16px;

  @media ${(props) => props.theme.mobile} {
    font-size: 14px;
  }
`
